import { Component } from "@angular/core";
import {
  ActivatedRoute,
  NavigationEnd,
  NavigationStart,
  ResolveEnd,
  Router
} from "@angular/router";
import { filter } from "rxjs/operators";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"]
})
export class AppComponent {

  showNav = false;
  title: string;
  banner_image: string;

  constructor(router: Router, _activated: ActivatedRoute) {
    router.events
      .pipe(filter(a => a instanceof NavigationStart))
      .subscribe(next => {
        if (next instanceof NavigationStart) {
          switch (next.url) {
            case "/world-ranking":
              this.title = "World Ranking";
              this.banner_image = "../../modules/custom/wa_angular/app/assets/images/banner-world-ranking.jpg";
              break;
            case "/world-cup-ranking":
              this.title = "World Cup Ranking";
              this.banner_image = "../../modules/custom/wa_angular/app/assets/images/banner-world-cup-ranking.jpg";
              break;
            case "/world-records":
              this.title = "World Records";
              this.banner_image = "../../modules/custom/wa_angular/app/assets/images/banner-world-records.jpg";
              break;
            case "/prize-precision":
              this.title = "Longines prize for precision";
              this.banner_image = "../../modules/custom/wa_angular/app/assets/images/banner-world-cup-ranking.jpg";
              break;
            default:
          }
        }
      });
  }

}
